import { createQueryKeys } from "@lukemorales/query-key-factory";

import type { CoreApiClient } from "../client";
import type { Multisensor } from "../types";

export const createMultisensorQueries = (api: CoreApiClient) => {
  const { client } = api;

  const list = async (buildingId: string): Promise<Multisensor[]> => {
    const { data, error } = await client.GET(`/buildings/{buildingId}/multisensors`, {
      params: { path: { buildingId } },
    });
    if (error) throw new Error(error.message);
    return data;
  };

  return {
    list,
    queries: createQueryKeys("multisensor", {
      building: (buildingId: string) => ({
        queryKey: [buildingId],
        queryFn: () => list(buildingId),
      }),
    }),
  };
};
